import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LanguageService } from '../../../core/language/language.service';
import { EServicesService } from '../e-services.service';
import { eServiceCategory } from '../../../core/models/eServiceCategory';

@Component({
  selector: 'app-e-services-subcategory',
  templateUrl: './e-services-subcategory.component.html'
})
export class EServicesSubcategoryComponent implements OnInit {

  private languageID: number;
  public pathname: string;

  public eServicesSubCategories: eServiceCategory[] = [];
  public loadedBraeadcrumb: boolean = false;

  constructor(private _route: ActivatedRoute,
    private _languageService: LanguageService,
    private _eServicesService: EServicesService) {
      this.languageID = this._languageService.selectedLanguageId;
     }

  ngOnInit() {    
    this.pathname = location.pathname;
    this._route.params.subscribe(params => {
        let parentId = + params['parentId'];        
        if (!isNaN(parentId) && parentId > 0) {
          this.getSubCategoriesByParentID(this.languageID, parentId);
      } else {
          console.log('Nedostaje parent id')
      }
    });
  }

  getSubCategoriesByParentID(languageId: number, parentId : number)
  {
    this._eServicesService.getAlleServicesSubCategories(languageId, parentId).subscribe(result => {      
      this.eServicesSubCategories = result;      

      if(this.eServicesSubCategories[0].parentAdmProcedureCategoryName != null)
      {
        let arrayPath = location.pathname.split('/');
        arrayPath[2] = arrayPath[2] + '|' + this.eServicesSubCategories[0].parentAdmProcedureCategoryName;
        this.pathname = arrayPath.join('/');        
      }
      this.loadedBraeadcrumb = true;

      if(this.eServicesSubCategories != null)     
        for(let i = 0; i < this.eServicesSubCategories.length; i++){
          this.getAdministrativeProceduresByCategoryID(languageId, this.eServicesSubCategories[i].id, i);          
        }
    });
  }

  getAdministrativeProceduresByCategoryID(languageId: number, categoryId : number, listIndex: number)
  {    
    this._eServicesService.getAdministrativeProceduresByCategoryID(languageId, categoryId).subscribe(result => {      
      this.eServicesSubCategories[listIndex].administrativeProcedure = result;  
    });
  }

}
